export default "__VITE_ASSET__a6460d74__"